<template>
<!-- 配置-抽成配置-订单模式抽成 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="8">
                        <span class="title">模式名称:</span>
                        <!-- 搜索商家名称 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入模式名称"
                            class="handle-input mr10"
                            @keyup.enter.native="searchBusinessLists"
                        ></el-input>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">开启状态:</span>

                        <el-select
                            v-model="search_data.status"
                            placeholder="请选择开启状态"
                            clearable
                            @keyup.enter.native="searchBusinessLists"
                        >
                            <el-option label="已开启" value="1"> </el-option>
                            <el-option label="未开启" value="0"> </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchOrderModeDeductionLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column label="订单模式名称" prop="name" min-width="100"> </el-table-column>
            <el-table-column label="全职司机扣除固定金额" prop="mode_amount" min-width="100"> </el-table-column>
            <el-table-column label="全职扣除订单金额百分比" prop="mode_rate" min-width="100"> </el-table-column>
            <el-table-column label="兼职司机扣除固定金额" prop="part_mode_amount" min-width="100"> </el-table-column>
            <el-table-column label="兼职扣除订单金额百分比" prop="part_mode_rate" min-width="100"> </el-table-column>
            <el-table-column label="按单扣除固定金额" prop="single_mode_amount" min-width="100"> </el-table-column>
            <el-table-column label="按单扣除订单金额百分比" prop="single_mode_rate" min-width="100"> </el-table-column>
            <el-table-column label="状态" prop="status.alias" min-width="100"> </el-table-column>
            <el-table-column label="操作" width="270" align="center">
                <template slot-scope="scope">
                    <el-button
                        type="primary"
                        trigger="click"
                        @click="
                            edit_isShow = !edit_isShow;
                            orderMode_code = scope.row.order_mode.order_mode_code;
                        "
                    >
                        编辑
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
        <!-- 编辑组件 -->
        <editOrderMode :isShow="edit_isShow" :data="orderMode_code" @onSubmit="orderModeDeductionLists"></editOrderMode>
    </div>
</template>
<script>
var _this;
import editOrderMode from './editOrderMode.vue';
export default {
    components: {
       
        editOrderMode
       
    },
    data() {
        return {
            edit_isShow: false,
            orderMode_code: '',
            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                status: ''
            },
            // 存放表格数据
            tableData: [],
            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.orderModeDeductionLists();
    },
    methods: {
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.orderModeDeductionLists();
        },
        searchOrderModeDeductionLists() {
            _this.search_data.page = 1;
            _this.orderModeDeductionLists();
        },
        orderModeDeductionLists() {
            _this
                .$post('/order/orderModeDeductionLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                  
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>